var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.494 4.914a2.832 2.832 0 0 0-5.237-2.161l-5.526 13.39-4.515 10.943a2.832 2.832 0 1 0 5.236 2.161l3.795-9.191h11.41l3.904 9.215a2.832 2.832 0 1 0 5.215-2.208L26.14 16.118l-.732-1.727H12.582l3.912-9.476zm3.884 7.417a3.026 3.026 0 1 0 0-6.05 3.026 3.026 0 0 0 0 6.05z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsm);
export default __webpack_public_path__ + "static/media/ASM.c863ad054e7c1bd001d22e9d4eebbc85.svg";
export { ForwardRef as ReactComponent };